export const example = (value) => {
  return value;
}
